/* eslint-disable max-len */
import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { useProvider } from 'utils/providers/Provider';

import { TOUR_SELECTOR } from '..';

const useGetHowToManageInvoice = () => {
  const { dispatch, state } = useProvider();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;

  const { TOUR } = TOUR_SELECTOR;

  const manageInvoiceSteps: StepType[] = [
    {
      content: 'Go to the Sales menu tab',
      selector: `[data-tut="${TOUR.SALES.MENU}"]`,
      position: 'right',
      disableActions: true,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
    },
    {
      content: 'Then select Invoice to view the Invoice page',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 600);
          },
          false,
        );
      },
    },
    {
      content:
        'View the invoice details by clicking on the three dots next to the desired invoice.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.THREE_DOTS_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 500);
          },
          false,
        );
      },
      padding: 10,
    },
    {
      content: 'Then select View',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.VIEW}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(4), 500);
          },
          false,
        );
      },
      position: 'top',
      padding: { popover: [0, 12] },
    },
    {
      stepInteraction: false,
      content: (props) => (
        <Content
          hideNote
          {...props}
          content={`
      To approve your created invoice, click on the Approved Draft button
      `}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.APPROVE_DRAFT}"]`,
    },
    {
      stepInteraction: false,
      content: (props) => (
        <Content
          hideNote
          {...props}
          content={`
      To edit your created invoice, click on the Edit Draft button
      `}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.EDIT_DRAFT}"]`,
    },
    {
      stepInteraction: false,
      content: (props) => (
        <Content
          hideNote
          {...props}
          content={`
            After the created invoice is approved, 
            you may send a copy of the invoice via email by clicking on the Send Invoice button. 
            After selecting this step, the user would have the option to either resend the invoice via email or download a copy of the invoice.
          `}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.SEND_INVOICE}"]`,
    },
    {
      stepInteraction: false,
      content: (props) => (
        <Content
          hideNote
          {...props}
          content={`
            You also have the option to skip sending an invoice and proceed immediately to the next step by clicking on the Skip Sending button. 
            After selecting this step, the user would have the option to either resend the invoice via email or download a copy of the invoice.
          `}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.SKIP_SENDING}"]`,
    },
    {
      stepInteraction: false,
      content: (props) => (
        <Content
          endTour
          hideNote
          {...props}
          content={`Once payment has been made, you can record payment by clicking on the Record Payment button.`}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.MANAGE.RECORD_PAYMENT}"]`,
      disableActions: false,
    },
  ];

  const showManageInvoiceSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(manageInvoiceSteps);
      setIsOpen(true);
    }, 300);
  };

  return showManageInvoiceSteps;
};

export default useGetHowToManageInvoice;
